export const settings = {
  apiBaseUrl: process.env.VUE_APP_API_BASE_URL,
  angularTemplatesBase: process.env.ANGULAR_TPL_BASE_URL,
  staticBase: process.env.STATIC_BASE
}